import { MonthYear } from './types';
import { DateTime } from 'luxon';

export const getMonthYearFromDate = (date: Date): MonthYear => {
    const luxonDate = DateTime.fromJSDate(date);
    return {
        month: luxonDate.month,
        year: luxonDate.year,
    };
};

export const calendarDayColors = {
    targetMonth: 'Dark-Text',
    nonTargetMonth: 'Grey-Light',
} as const;
